import axios from './axios';

const getMetricsAlarmHistory = params =>
  axios({
    method: 'get',
    url: '/v2/machines/metrics/alarm-history',
    params
  });

export { getMetricsAlarmHistory };
